import React from 'react';
import moment from 'moment';
import { Typography } from '@mui/material';
import { IHeaderData } from '../interfaces';
import { useStyles } from '../styles';

interface IFirstLineProps {
  data: IHeaderData;
}
export const FirstLine = ({ data: { isFeatured, expiryDate } }:IFirstLineProps) => {
  const classes = useStyles();
  if (moment(expiryDate).isAfter(moment())) {
    return (
      <Typography
        className={classes.comment}
        marginBottom={1}
      >
        This
        {' '}
        <span style={{ fontWeight: 700 }}>
          {isFeatured ? 'Featured' : 'Standard'}
          {' '}
          Job Listing
          {' '}
        </span>
        is set to expire on
        {' '}
        {moment(expiryDate).format('MM/DD/YYYY')}
        .
      </Typography>
    );
  }
  return (
    <Typography
      className={classes.comment}
      marginBottom={1}
    >
      This
      {' '}
      <span style={{ fontWeight: 700 }}>
        {isFeatured ? 'Featured' : 'Standard'}
        {' '}
        Job Listing
      </span>
      <span style={{ fontWeight: 700, color: 'red' }}> Expired </span>
      on
      {' '}
      {moment(expiryDate).format('MM/DD/YYYY')}
      .
      It is no longer visible to our users.
    </Typography>
  );
};
